export default "__VITE_PUBLIC_ASSET__6fa63c08__"